import { useState, useEffect, useCallback, useRef } from "react";

import { Account } from "../bitmaker/schemas/Account";

import { useApiError } from "./useApiError";
import { BitmakerAPIClient } from "../services/BitmakerApp";

export const useAccounts = () => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const [fetchAccountsError, setFetchAccountsError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchAccounts = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingAccounts(true);
    setFetchAccountsError(null);

    BitmakerAPIClient.get("/accounts", null, (response: any) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching accounts:", message);
        setFetchAccountsError("Error fetching accounts. Please try again.");
        setLoadingAccounts(false);
        return;
      }

      const data = Array.isArray(response.data)
        ? (response.data as Account[])
        : [];

      setAccounts(data);
      setLoadingAccounts(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  return {
    accounts,
    loadingAccounts,
    fetchAccountsError,
    refetchAccounts: fetchAccounts,
  };
};
